import { render, staticRenderFns } from "./crm-client-setting-form.vue?vue&type=template&id=e36eb808"
import script from "./crm-client-setting-form.vue?vue&type=script&lang=js"
export * from "./crm-client-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports